import { shadowEffects } from '../primitives/shadows';

/** Chakra shadow semantic tokens — derived from {@link shadowEffects}. */
export const shadows = {
  menu: { value: shadowEffects.menu },
  popup: { value: shadowEffects.popup },
  none: { value: 'none' },
};

export type ShadowToken = keyof typeof shadows;
